/**
 * <ps-swipe> – Punkte-Indikator für horizontale Mobile-Swipes (#30).
 * Erwartet [data-swipe-track] (scrollende Liste), [data-swipe-dot] und [data-swipe-status].
 * Ohne JS bleibt der erste Punkt aktiv; der Swipe selbst ist reines CSS.
 */
class PsSwipe extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-swipe-track]');
    this.dots = [...this.querySelectorAll('[data-swipe-dot]')];
    this.status = this.querySelector('[data-swipe-status]');
    this.current = 0;
    if (!this.track || this.dots.length < 2) return;

    this.onScroll = () => this.update();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  update() {
    const track = this.track;
    const first = track.firstElementChild;
    if (!first) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = first.getBoundingClientRect().width + gap;
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    const last = this.dots.length - 1;
    const index = atEnd ? last : Math.min(last, Math.round(track.scrollLeft / step));
    if (index === this.current) return;

    this.current = index;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    this.status?.setAttribute('aria-label', `Karte ${index + 1} von ${this.dots.length}`);
  }
}

if (!customElements.get('ps-swipe')) customElements.define('ps-swipe', PsSwipe);
